import { ContextBuilder } from "./ContextBuilder";
import { Engine } from "..";
import { TextManager } from "../Text/TextManager";
import { WebGLContextBuilder } from "./WebGLContextBuilder";
import { DOMTextManager } from "../Text/DOMTextManager";
import { ResourceLoader } from "@spi/Common/Resource/ResourceLoader";
import { HttpLoadingStrategy } from "@spi/Common/Resource/HttpLoadingStrategy";
import { ViewPort } from "../View";

export class DOMContextBuilder extends ContextBuilder {
    
    constructor(viewPort: ViewPort, public canvas: HTMLCanvasElement, public overlayLayer: HTMLDivElement) {
        super(viewPort);
    }

    buildResourceLoader(): ResourceLoader {
        return new ResourceLoader(new HttpLoadingStrategy());
    }

    buildWebGLContext(engine: Engine): WebGLRenderingContext {

        let gl = this.canvas.getContext("webgl", { preserveDrawingBuffer: true });
        this.canvas.width = this.viewPort.width;
        this.canvas.height = this.viewPort.height;
        this.canvas.style.width = this.viewPort.width + 'px';
        this.canvas.style.height = this.viewPort.height + 'px';
        return new WebGLContextBuilder()
            .build(gl);
    }

    buildTextManager(engine: Engine): TextManager {
        return new DOMTextManager(this.overlayLayer);
    }
}